import React from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { PersonOutlineOutlinedIcon, LinkOutlinedIcon, FilterAltOutlinedIcon, EmailOutlinedIcon, QrCodeOutlinedIcon, VideocamOutlinedIcon, DriveFileRenameOutlineOutlinedIcon, ShoppingBagOutlinedIcon } from 'icons/materialIcons';
import { useLocation } from 'react-router-dom';

const EditCardSidenav = ({ onMenuItemClick }) => {
  const location = useLocation();
  const isNewCard = location.pathname.includes('/add-card/');

  const listItemStyle = {
    padding: '4px 8px',
    whiteSpace: 'nowrap',
    minHeight: '40px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    }
  };

  const listItemTextStyle = {
    margin: 0,
    '& .MuiTypography-root': {
      fontSize: '0.8rem',
      fontWeight: 600,
      color: "#4f4f4f",
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  };

  const iconStyle = {
    minWidth: '32px',
    marginRight: 0.5
  };

  return (
    <Box
      sx={{
        display: { xs: 'none', sm: 'block' },
        backgroundColor: '#ff',
        borderRadius: '8px 0 0 8px',
      }}
    >
      <Box sx={{ marginTop: 2 }}>
        {/* Content Section - Always visible */}
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            textTransform: 'uppercase',
            marginBottom: 1,
            fontSize: '0.8rem',
            color: '#8e8e8e',
            paddingLeft: '12px'
          }}
        >
          Content
        </Typography>
        <List sx={{ '& .MuiListItem-root': listItemStyle }}>
          <ListItem onClick={() => onMenuItemClick('about')}>
            <ListItemIcon sx={iconStyle}>
              <PersonOutlineOutlinedIcon sx={{ fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText
              primary="About"
              sx={listItemTextStyle}
            />
          </ListItem>
          <ListItem onClick={() => onMenuItemClick('links')}>
            <ListItemIcon sx={iconStyle}>
              <LinkOutlinedIcon sx={{ fontSize: 20 }} />
            </ListItemIcon>
            <ListItemText
              primary="Links"
              sx={listItemTextStyle}
            />
          </ListItem>
        </List>

        {/* Additional Sections - Only show if not a new card */}
        {!isNewCard && (
          <>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 600,
                textTransform: 'uppercase',
                marginTop: 2,
                marginBottom: 1,
                fontSize: '0.8rem',
                color: '#8e8e8e',
                paddingLeft: '12px'
              }}
            >
              Lead Capture
            </Typography>
            <List sx={{ '& .MuiListItem-root': listItemStyle }}>
              <ListItem onClick={() => onMenuItemClick('leadCaptureForm')}>
                <ListItemIcon sx={iconStyle}>
                  <FilterAltOutlinedIcon sx={{ fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText
                  primary="Lead Capture Form"
                  sx={listItemTextStyle}
                />
              </ListItem>
              <ListItem onClick={() => onMenuItemClick('followUpEmail')}>
                <ListItemIcon sx={iconStyle}>
                  <EmailOutlinedIcon sx={{ fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText
                  primary="Follow Up Email"
                  sx={listItemTextStyle}
                />
              </ListItem>
            </List>

            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 600,
                textTransform: 'uppercase',
                marginTop: 2,
                marginBottom: 1,
                fontSize: '0.8rem',
                color: '#8e8e8e',
                paddingLeft: '12px'
              }}
            >
              Sharing
            </Typography>
            <List sx={{ '& .MuiListItem-root': listItemStyle }}>
              <ListItem onClick={() => onMenuItemClick('qrCode')}>
                <ListItemIcon sx={iconStyle}>
                  <QrCodeOutlinedIcon sx={{ fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText
                  primary="QR Code"
                  sx={listItemTextStyle}
                />
              </ListItem>
              <ListItem onClick={() => onMenuItemClick('virtualBackground')}>
                <ListItemIcon sx={iconStyle}>
                  <VideocamOutlinedIcon sx={{ fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText
                  primary="Virtual Background"
                  sx={listItemTextStyle}
                />
              </ListItem>
              <ListItem onClick={() => onMenuItemClick('emailSignature')}>
                <ListItemIcon sx={iconStyle}>
                  <DriveFileRenameOutlineOutlinedIcon sx={{ fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText
                  primary="Email Signature"
                  sx={listItemTextStyle}
                />
              </ListItem>
              <ListItem onClick={() => onMenuItemClick('accessories')}>
                <ListItemIcon sx={iconStyle}>
                  <PersonOutlineOutlinedIcon sx={{ fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText
                  primary="Accessories"
                  sx={listItemTextStyle}
                />
              </ListItem>
            </List>
          </>
        )}
      </Box>
    </Box>
  );
};

export default EditCardSidenav;